import { TableColumn } from '../../../components/_EOS/GenericTable/types'
import { Asn } from '../../../interfaces/Asn/Asn'
import { ProductOrigin } from '../../../interfaces/Producto/ProductOrigins'
import { utcToLocal } from '../../../utils/dateHelper'

export const getColumnsConfig = (
  productOrigins?: ProductOrigin[]
): TableColumn<Asn>[] => [
  {
    key: 'asnId' as keyof Asn,
    title: 'ID',
    sortable: true,
    render: (value) => value
  },
  {
    key: 'asnNumber' as keyof Asn,
    title: 'Nro ASN',
    sortable: true,
    render: (value) => value
  },
  {
    key: 'createdDate' as keyof Asn,
    title: 'Fecha Creación',
    sortable: true,
    render: (value) => utcToLocal((value as string) || '', 'dd/MM/yyyy')
  },
  {
    key: 'asnStateName' as keyof Asn,
    title: 'Estado',
    sortable: true,
    render: (value) => value
  },
  {
    key: 'supplierName' as keyof Asn,
    title: 'Proveedor',
    sortable: true,
    render: (value) => value
  },
  {
    key: 'supplierOriginName' as keyof Asn,
    title: 'Origen',
    sortable: true,
    render: (value) => value
  },
  {
    key: 'brandId' as keyof Asn,
    title: 'Marca',
    sortable: true,
    render: (value, _row: Asn) => {
      return (
        productOrigins?.find((el) => el.productOriginId === value)?.name ||
        'Sin Marca'
      )
    }
  },
  {
    key: 'realQty' as keyof Asn,
    title: 'Unidades',
    sortable: true,
    render: (value) => value
  }
]
